import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, Image, TextInput } from '../../types'
import { CmsConverterService, defaultTextInput } from '../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class UspBoxConverter extends CmsConverterService<UspBoxData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    const title = formData.st_image_title_text?.value
    const altText = formData.st_alt_text?.value
    const lazyLoad = formData.st_image_lazy_loading?.value
    return {
      image: CmsConverterService.mapImage(formData.st_image_reference, lazyLoad, altText, title),
      description: formData.st_text ?? defaultTextInput,
    }
  }
}

export const USP_BOX_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, UspBoxData>>('UspBoxConverter')

export interface UspBoxData extends ConvertedComponentData {
  image: Image;
  description: TextInput;
}
